import React, { FC } from 'react'
import { css } from 'styled-components'
import { FeedbotSuspense } from './design-system/FeedbotSuspense'

type Props = {}

// This Suspense wrapper should ideally NEVER trigger.
// But in case it does (some lazy component is missing its own suspense wrapper),
// we want this wrapper to trigger instead of an app crash.
// We want it to be weird and noticable, so users will report it happening
export const GlobalSuspenseDecorator: FC<Props> = ({ children }) => {
  return (
    <FeedbotSuspense
      name="Global (this should not happen)"
      fallback={<div css={import.meta.env.DEV && devCss} />}
    >
      {children}
    </FeedbotSuspense>
  )
}

const devCss = css`
  width: 100vw;
  height: 100vh;
  background-color: green;
`
export type GlobalSuspenseDecoratorProps = Props
